import { render, staticRenderFns } from "./NewNewsPage.vue?vue&type=template&id=401dd089&"
import script from "./NewNewsPage.vue?vue&type=script&lang=js&"
export * from "./NewNewsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports